import type { User } from 'api/data.types'

import { initSupportChat } from 'utils/support-chat'
import {
  initSprinklrChat,
  shouldShowSprinklrChat
} from 'utils/sprinklr-chat/sprinklrChat'

export function startChatApplication(user: User) {
  if (shouldShowSprinklrChat(user)) {
    initSprinklrChat()
  } else {
    initSupportChat()
  }
}
